import { ModalCrearOF } from "@/components/modals/CrearOF/CrearOF";
import { useMemo, useState } from "react";
import { createColumnHelper, tableFeatures } from "@tanstack/react-table";
import { CommonFeatures } from "@/hooks/useTanstackTable";
import { TypedTable } from "@/components/ui/table/TypedTable";
import type { ArticuloFabricacion } from "@/hooks/Api/Articulos";

interface TablaArticulosProps {
	readonly data: ArticuloFabricacion[] | null | undefined;
	readonly error: Error | null;
	readonly isPending: boolean;
}
export function TablaArticulos(props: TablaArticulosProps) {
	const [artCreandoOF, setArtCreandoOF] = useState<string | null>(null);
	const { data, error, isPending } = props;

	const { columns, features } = useMemo(() => Columns(), []);

	const onClickDT = (event: React.MouseEvent<HTMLDivElement>) => {
		const target = (event.target as HTMLElement | null)?.closest(".mostrarModalLanzarOF") as HTMLElement | null;
		if (!target) {
			return;
		}
		const idArticulo = target.dataset.idArticulo;
		if (idArticulo != null) {
			setArtCreandoOF(idArticulo);
		}
	};

	return (
		<>
			<div onClick={onClickDT}>
				<TypedTable
					className="dataTable display"
					data={data ?? []}
					columns={columns}
					features={features}

					noResultsMessage="No se encontraron resultados"
					errorMessage={error?.message ?? "Error al cargar los artículos"}
					isLoading={isPending}
					isError={error != null}

					pagination
					globalSearch
				/>
			</div>

			<ModalCrearOF
				show={artCreandoOF != null}
				close={() => { setArtCreandoOF(null); }}
				idArticulo={artCreandoOF}
			/>
		</>
	);
}


function Columns() {
	const columnHelper = createColumnHelper<typeof features, ArticuloFabricacion>();

	const features = tableFeatures(CommonFeatures);

	const formatter = new Intl.NumberFormat("es-ES", { maximumFractionDigits: 2, minimumFractionDigits: 0 });
	const defaultNumberFormat = (value: number | null) => value == null ? "-" : formatter.format(value);

	const getAccionesArticulo = (articulo: ArticuloFabricacion) => {
		if ((articulo.tipoArticulo == 2 || articulo.tipoArticulo == 5) && articulo.rutaFabricacion != null) {
			return (
				<div className="clickable tableButton mostrarModalLanzarOF" data-id-articulo={articulo.idArticulo}>
					<i className="fa fa-plus" />
				</div>
			);
		} else {
			return <div style={{ width: "36px" }} />;	// placeholder to somewhat keep the column width consistent
		}
	};

	const columns = columnHelper.columns([
		columnHelper.accessor("nombreFamilia", { header: "Familia", cell: info => info.getValue() ?? "-", meta: { className: "dt-center" } }),
		columnHelper.accessor("nombreSubFamilia", { header: "Subfamilia", cell: info => info.getValue() ?? "-", meta: { className: "dt-center" } }),
		columnHelper.accessor(info => `${info.idArticulo} - ${info.nombreArticulo}`, { id: "articulo", header: "Artículo", meta: { className: "dt-center" } }),

		// columnHelper.accessor("m382_xpeso", { header: "Peso", cell: info => defaultNumberFormat(info.getValue()), meta: { className: "dt-center" } }),
		columnHelper.accessor("max", { header: "Máximo", cell: info => defaultNumberFormat(info.getValue()), meta: { className: "dt-center" } }),
		columnHelper.accessor("min", { header: "Mínimo", cell: info => defaultNumberFormat(info.getValue()), meta: { className: "dt-center" } }),
		columnHelper.accessor("pendienteEntrada", { header: "Pdte. Entrada", cell: info => defaultNumberFormat(info.getValue()), meta: { className: "dt-center" } }),
		columnHelper.accessor("pendienteSalida", { header: "Pdte. Salida", cell: info => defaultNumberFormat(info.getValue()), meta: { className: "dt-center" } }),
		columnHelper.accessor("stock", { header: "Existencias", cell: info => defaultNumberFormat(info.getValue()), meta: { className: "dt-center" } }),
		columnHelper.accessor("entrarRecomendado", { header: "PEDIR", cell: info => defaultNumberFormat(info.getValue()), meta: { className: "dt-center" } }),
		// columnHelper.accessor("ped_lista", { header: "Pdte. Empaquetar", cell: info => defaultNumberFormat(info.getValue()), meta: { className: "dt-center" } }),

		columnHelper.display({
			id: "actions",
			header: "",
			meta: { className: "p-0 h-full" },
			cell: ({ row }) => getAccionesArticulo(row.original),
		}),

	]);
	return { columns, features };
}